import { Component} from '@angular/core';
import { AuthenticationService } from '../../security/authentication-service';
import { GenericCrudService } from '../../services/generic-crud.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent {
  credentials = { login: '', senha: '' };
  loginInProgress = false;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    public authService: AuthenticationService,
    private crudService: GenericCrudService,
  ) {
    if (authService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
  }

  login(): void {
    this.spinner.show();
    this.loginInProgress = true;

    this.authService.authenticate(this.credentials, (result: any, resultError: any) => {
      this.loginInProgress = false;
      this.spinner.hide();
      if (result) {
        this.router.navigate(['/obrigacoes-acessorias']);
      } else {
        if (resultError?.error?.detail) {
          this.crudService.snackError(resultError.error.detail);
        } else {
          this.crudService.snackError('Erro no login');
        }
      }
    });
  }
}
